import * as React from 'react';

import { Box, Flex } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { Progress } from '@lightspeed/flame/Progress';
import { Text } from '@lightspeed/flame/Text';

import { StatusDataContext } from 'root/apps/InventoryCount/contexts/StatusData';

const ImportProgress: React.FC = () => {
  const { data, getStatusData } = React.useContext(StatusDataContext);
  const [importProgress, setImportProgress] = React.useState(0);

  React.useEffect(() => {
    if (data?.progress) {
      setImportProgress(data.progress);
    }

    const progressBar = setInterval(() => {
      getStatusData();
    }, 3000);

    return () => clearInterval(progressBar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.progress]);

  return (
    <Box data-test="import-progress-view" px={5} py={50} height={350}>
      <Flex flexDirection="column" justifyContent="space-between" alignItems="center" height="100%">
        <img
          style={{ width: '250px', alignSelf: 'center' }}
          alt="empty table"
          src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/import-items.svg"
        />
        <Text size="large" fontWeight={600} color={theme.colors.black}>
          Importing items
        </Text>
        <Box textAlign="center" pb={2}>
          <Text>You can safely navigate away from this page.</Text>
        </Box>
        <Progress type="determinate" total={100} current={importProgress} />
      </Flex>
    </Box>
  );
};

export default ImportProgress;
